import React, { useState } from 'react'
import { Grid } from "@mui/material";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from '../../../../../../_uiComponents/telerikComponents/UiInput'
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../../_uiComponents/common/form/UiButton";

import { UiRadioButton } from '../../../../../../_uiComponents/telerikComponents/UiRadioButton';
import { UiCheckBox } from '../../../../../../_uiComponents/telerikComponents/UiCheckBox';

export default function GameplayWinningSlotConfigurationForm(props) {


    const radioValidator = value => value ? '' : 'Total Reward Slots is required.';
    const inputValidator = value => value ? '' : 'Total Unlucky Slots is required.';

    const [fieldChecked, setFieldChecked] = useState();

    const handleSubmit = dataItem => {
        const payload = {
            GamePlayRadio: fieldChecked,
            GamePlayInput: dataItem.gamePlayInput
        }

    }

    const handleCheckBoxChange = (e) => {

    }

    return (
        <>

            <UiInputGroupWr
                title="Gameplay Wheel Configuration"
            >
                <Form onSubmit={handleSubmit}
                    render={formRenderProps =>
                        <>
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                >
                                    <div className="sb-game-play-wrapper">
                                        <Field name={'gamePlay'}
                                            validator={radioValidator}
                                            component={UiRadioButton}
                                            handleChange={handleCheckBoxChange}
                                            value={'gamePlay'}
                                            labelClassName={'k-form-label'}
                                        />

                                        <span className="sb-game-play-wrapper__span"> Continuous Wining Game Play </span>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs={12}
                                    lg={12}
                                >
                                    <div className="sb-game-play-wrapper">

                                        <Field name={'gamePlay'}
                                            validator={radioValidator}
                                            component={UiRadioButton}
                                            handleChange={handleCheckBoxChange}
                                            value={'gamePlay'}
                                            labelClassName={'k-form-label'}
                                        />

                                        <span className="sb-game-play-wrapper__span"> Win After Every </span>
                                        <Field name={'gamePlayInput'}
                                            validator={inputValidator}
                                            component={UiInput}
                                            labelClassName={'k-form-label'}
                                        />
                                        <span className="sb-game-play-wrapper__span">Unlucky Game Play</span>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs={12}
                                    lg={12}
                                >
                                    <div className="sb-game-play-wrapper">

                                        <Field name={'gamePlay'}
                                            validator={radioValidator}
                                            component={UiRadioButton}
                                            handleChange={handleCheckBoxChange}
                                            value={'gamePlay'}
                                            labelClassName={'k-form-label'}
                                        />

                                        <span className="sb-game-play-wrapper__span">Shuffle Rewards Between </span>
                                        <Field name={'gamePlayInput'}
                                            validator={inputValidator}
                                            component={UiInput}
                                            labelClassName={'k-form-label'}
                                        />
                                        <span className="sb-game-play-wrapper__span">Game Play</span>
                                    </div>
                                </Grid>
                            </Grid>


                            <Grid container spacing={2} sx={{ mb: 1 }}>

                                <Grid item xs={12} lg={12} sx={{ mb: 2 }} >
                                    <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                        <UiButton
                                            name="Cancel"
                                            variant="outlined"
                                            size="small"
                                            onClick={formRenderProps.onFormReset}
                                        />
                                        <UiButton
                                            name="Save"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />
                                    </Stack>
                                </Grid>
                            </Grid>
                        </>
                    }
                />

            </UiInputGroupWr>


        </>
    )
}
